module.exports = __webpack_public_path__ + "img/MoreCritical.dbca4c7b.png";